import React from 'react';
import { Flex, Box, Spinner, Heading } from '@podiumhq/design-system';
import useLoadingMessagesRotation from 'components/Trials/hooks/useLoadingMessagesRotation';

const CreatingBusinessNumber = () => {
  const loadingMessages = [
    'We’re building a consolidated Inbox to rule them all...',
    'We’re creating text templates so you can just hit “Send”...',
    'We’re creating a chat tool that you can add to your website...',
    'We’re inventing new ways to help your business grow...',
  ];

  const loadingMessage = useLoadingMessagesRotation({
    loadingMessages: loadingMessages,
  });

  return (
    <Box position="fixed" bg="#12151A" w="100vw" h="100vh" top="0" left="0">
      <Flex
        justifyContent="center"
        alignItems="center"
        flexDir="column"
        h="100vh"
      >
        <Spinner
          size="md"
          speed="0.5s"
          emptyColor="black.lightest"
          color="white"
        />
        <Heading color="white" {...headingStyles}>
          {loadingMessage}
        </Heading>
      </Flex>
    </Box>
  );
};

const headingStyles = {
  fontSize: 'xl',
  fontWeight: 'medium',
  margin: '24px',
  textAlign: 'center',
};

export default CreatingBusinessNumber;
